<template>
	<div>
		<client-module class="header-title" :moduletitle="moduletitle" hideBorder>
			<filter-panel style="width: 100%" :data="group" @search="filterChange"></filter-panel>
		</client-module>
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="columns"
			:loading="loading"
			:btnList="btnList"
			:custom="custom"
			:hint="hint"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<dialog-form
			:dialogVisible="showDialog"
			:attributes="attributes"
			:formData="formData"
			@close:dialogVisible="
				val => {
					showDialog = val;
				}
			"
			@confirm="confirm"
		>
			<div slot="main" class="temporary-hint" v-if="$route.query.type == 1">
				使用%创建通配符邮箱将该域名下所有邮箱加入黑名单。例如，%@abc.com包含111@abc.com、222@abc.com和333@abc.com等。
			</div>
		</dialog-form>
		<el-dialog title="移除确认" :visible.sync="removeVisible" width="30%">
			<el-scrollbar>
				<p class="content">
					是否将
					<span>"{{ content }}"</span>从黑名单中移除？
				</p>
			</el-scrollbar>
			<p>
				<el-checkbox v-model="checked" true-label="1" false-label="0"
					>同时移入内容白名单（白名单的内容不会被系统判定进入黑名单）</el-checkbox
				>
			</p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="removeVisible = false">取 消</el-button>
				<el-button type="primary" @click="remove()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import garbageInquiry from '@/backend/services/garbageInquiry/garbageInquiry.js';
import clientModule from '@/components/client/clientModule/clientModule.vue';
import dialogForm from '@/components/dialogForm/dialogForm';
import { validRequired } from '@/common/elementValid.js';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
const list = listPageCreate({
	searchConfig: {
		api: api.garbageInquiry.filterRuleList,
		method: 'POST',
	},
	getQuery(object, that) {
		let type = that.$route.query.type;
		return _.assign(object, {
			type,
		});
	},
});
export default {
	mixins: [list],
	data() {
		return {
			moduletitle: '',
			columns: [],
			btnList: [],
			custom: {},
			hint: {},
			attributes: {
				title: '新增过滤规则',
			},
			showDialog: false,
			formData: {},
			updateId: '',
			group: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '关键词',
						label: '关键词',
						prop: 'keyword',
						value: '',
					},
				],
			},
			removeVisible: false,
			content: '',
			id: '',
			checked: 0,
		};
	},
	mounted() {
		this.setColumns();
		this.query();
	},
	methods: {
		setColumns() {
			let name = ['邮件地址', '邮件内容', '关键词'];
			let { type } = this.$route.query;
			let that = this;
			this.moduletitle = `${name[type - 1]}黑名单`;
			this.columns = [
				{
					label: name[type - 1],
					bind: 'content',
					showOverflowTooltip: true,
				},
				{
					label: '添加时间',
					bind: 'createTime',
				},
				{
					label: '添加人',
					bind: 'createrName',
				},
				{
					label: '影响客户',
					bind: 'customerNum',
				},
				{
					label: '累计过滤垃圾',
					bind: 'inquiryNum',
					type: 'percentage',
					style: {
						color: '#409EFF',
						cursor: 'pointer',
					},
					webskip(val, row) {
						that.$router.push({
							name: 'audit',
							query: {
								id: row.id,
								type: 4,
							},
						});
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					bind: [
						{
							text: '编辑',
							trigger(row) {
								that.showDialog = true;
								that.setFormData(row);
							},
						},
						{
							text: '移除',
							async trigger(row) {
								if (type == 2) {
									that.content = row.content;
									that.id = row.id;
									that.checked = 0;
									that.removeVisible = true;
								} else {
									that.remove(row.id, 0);
								}
							},
						},
					],
				},
			];
			this.btnList = [
				{
					name: '新增',
					position: 'right',
					attribute: {
						type: 'primary',
					},
					btnClick() {
						that.setFormData();
						that.showDialog = true;
					},
				},
			];
			this.hint = {
				content: '',
			};
		},
		async remove(id, type) {
			let res = await garbageInquiry.deleteFilterRule({
				id: id ? id : this.id,
				type: type ? type : this.checked, //0否1是
			});
			if (res.status == 200) {
				this.removeVisible = false;
				this.$message.success('移除成功');
				this.query();
			}
		},
		setFormData(obj = {}) {
			let name = ['邮件地址', '邮件内容', '关键词'];
			let { type } = this.$route.query;
			this.updateId = obj.id;
			this.formData = {
				content: {
					label: name[type - 1],
					formType: 'sky-textarea',
					autosize: { minRows: 2 },
					value: obj.content,
					rules: [validRequired('此项必填')],
				},
			};
		},
		// 确定
		async confirm(cb) {
			try {
				let { formData, updateId } = this;
				let { type } = this.$route.query;
				let res = await garbageInquiry.addFilterRule({
					content: formData.content.value,
					type,
					id: updateId,
				});
				if (res.status === 200) {
					let message = updateId ? '编辑成功' : '新增成功';
					this.$message.success(message);
					this.query();
					cb();
				}
			} catch (error) {
				cb(false);
			}
		},
	},
	watch: {
		page: {
			handler(val) {
				this.hint = {
					content: `总计：${val.totalRecords}条`,
				};
			},
			deep: true,
			immediate: true,
		},
	},
	components: { clientModule, dialogForm, filterPanel },
};
</script>

<style lang="scss" scoped>
.header-title {
	background-color: #fff;
}

.content {
	max-height: 500px;
	padding-bottom: 20px;

	.span {
		font-weight: bolder;
	}
}

.el-scrollbar__wrap {
	overflow: scroll;
	width: 110%;
	height: 120%;
}
</style>
